/**
 * @module Services/Bff/Presenters/Request/Search
 * @desc Search Request Presenter
 *
 */

import type { Search } from 'core/domains';
import type { ProductRequestOptions } from 'core/services/bff/@types';

import { hasPayload } from './utilities';

/**
 * Transforms the search request payload from the domain to the request options
 *
 */
export function searchPresenter(
  payload: undefined | Search['queryOptions']['query'],
): undefined | ProductRequestOptions {
  if (!hasPayload(payload)) {
    return;
  }

  const isSku = payload.match(/^[0-9]+$/) != null;

  if (payload.length >= 3 && isSku) {
    return { sku: payload };
  }

  return {
    ...(payload ? { text: payload } : {}),
  };
}
